/* eslint-disable import/prefer-default-export */
export const toggleLoginModal = () => dispatch => {
  dispatch({
    type: 'TOGGLE_LOGIN_MODAL',
  });
};
